module.exports = __webpack_public_path__ + "img/life-at-ommax-1.a21f7ff6.jpg";